//加法
export function add(a, b) {
    return this.$math.number(this.$math.add(this.$math.bignumber(a), this.$math.bignumber(b)))
}

//减法
export function subtract(a, b) {
    return this.$math.number(this.$math.subtract(this.$math.bignumber(a), this.$math.bignumber(b)))
}

//乘法
export function multiply(a, b) {
    return this.$math.number(this.$math.multiply(this.$math.bignumber(a), this.$math.bignumber(b)))
}

//除法
export function divide(a, b) {
    return this.$math.number(this.$math.divide(this.$math.bignumber(a), this.$math.bignumber(b)))
}


//舍位法
export function roundDown(val, scale) {
    let f = Math.pow(10, scale)
    let a = Math.floor(this.$multiply(val, f))
    let b = this.$divide(a, f)
    return this.$accounting.toFixed(b, scale)
}

//进位法
export function roundUp(val, scale) {
    let f = Math.pow(10, scale)
    let a = Math.ceil(this.$multiply(val, f))
    let b = this.$divide(a, f)
    return this.$accounting.toFixed(b, scale)
}

//四舍五入
export function roundHalfUp(val, scale) {
    let f = Math.pow(10, scale)
    let a = this.$accounting.toFixed(this.$multiply(val, f), 0)
    return this.$accounting.toFixed(this.$divide(a, f), scale)
}




// WEBPACK FOOTER //
// ./src/common/js/util/calculate.js